import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '../services/auth.service';
import { Observable } from 'rxjs';
import { Roles } from '../../shared/constants/enum';

@Injectable({ providedIn: 'root' })
export class LoginGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const currentUser = this.authenticationService.currentUserValue;

    if (currentUser) {
      // User is already logged in
      const userRole = currentUser?.currentUserRoleDetails?.role;
      if (userRole === Roles.ADMIN || userRole === Roles.DASHBOARDADMIN) {
        this.router.navigate(['/admindashboard']);
      } else if (userRole === Roles.EVADMIN) {
        this.router.navigate(['/evReadings']);
      } else if (userRole === Roles.AGENTADMIN) {
        this.router.navigate(['/metersDatabase']);
      } else if (userRole) {
        const normalizedRole = userRole
          .toString()
          .toLowerCase()
          .replace(/\s+/g, '');
        const normalizedSgld = Roles.SGLDADMIN.toLowerCase().replace(/\s+/g, '');
        const normalizedDashboardAdmin = Roles.DASHBOARDADMIN.toLowerCase().replace(/\s+/g, '');
        const normalizedEvAdmin = Roles.EVADMIN.toLowerCase().replace(/\s+/g, '');
        const normalizedAgentAdmin=Roles.AGENTADMIN.toLowerCase().replace(/\s+/g, '');
        if (normalizedRole === normalizedSgld) {
          this.router.navigate(['/sgld-admindashboard']);
        } else if (normalizedRole === normalizedDashboardAdmin) {
          this.router.navigate(['/admindashboard']);
        } else if (normalizedRole === normalizedEvAdmin) {
          this.router.navigate(['/evReadings']);
        } else if (normalizedRole === normalizedAgentAdmin) {
          this.router.navigate(['/metersDatabase']);
        } else {
          this.router.navigate(['/dashboard']);
        }
      } else {
        this.router.navigate(['/dashboard']);
      }
      return false; // Prevent navigation to login page
    }

    return true; // Allow access to login page
  }
}
